// This store is used to track modals.value that are open
// allows "escapeOnClose" to only close the top-most modal rather than all modals.value

import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

export const useModalStore = defineStore('modal', () => {
  const modals = ref([]);

  // This function is called by Modal component when a modal is opened
  // It adds the modal to the stack
  const openedModal = (modalId) => {
    modals.value.push(modalId);
  };

  // This function is called by Modal component when a modal is closed
  // It removes the modal from the stack
  const closedModal = (modalId) => {
    const index = modals.value.indexOf(modalId);
    if (index !== -1) {
      modals.value.splice(index, 1);
    }
  };

  // This function is called by Modal component to check if a modal
  // can be closed using the escape key
  // It checks if the modal is the top-most modal in the stack
  // If it is, it returns true, otherwise it returns false
  const topModal = computed(() => {
    const topModal = modals.value[modals.value.length - 1];
    return topModal;
  });

  return {
    topModal,
    openedModal,
    closedModal,
  };
});
